import amex from 'component-library/assets/icons/amex_logo.svg';
import visa from 'component-library/assets/icons/visa_logo.svg';
import mastercard from 'component-library/assets/icons/mastercard_logo.svg';

export const creditCardsInfo = (cardNumber) => {
	const firstDigit = cardNumber.slice(0, 1);
	const firstTwoDigits = cardNumber.slice(0, 2);

	if (firstTwoDigits === '34' || firstTwoDigits === '37') {
		return {
			name: 'amex',
			securityCodelength: 4,
			ccLength: 15,
			logo: amex,
		};
	} else if (firstTwoDigits >= '51' && firstTwoDigits <= '55') {
		return {
			name: 'mastercard',
			securityCodelength: 3,
			ccLength: 16,
			logo: mastercard,
		};
	} else if (firstDigit === '4') {
		return {
			name: 'visa',
			securityCodelength: 3,
			ccLength: 16,
			logo: visa,
		};
	} else
		return {
			name: 'others',
			securityCodelength: 3,
			ccLength: 16,
			logo: '',
		};
};
